import { ProjectProgressionAggregatedTableTypeEnum } from '@linearb/linjs-common';
import { PM_PROVIDERS } from 'common/constants/constants';
import {
  PROGRESSION_CHILD_MODEL,
  PROGRESSION_MODEL
} from './table-layouts/model';
import {
  azureBoardsViewer,
  jiraViewer
} from 'components/hooks/PM/pm-provider-viewers';
import { startCase } from 'lodash';

export const generateTableTypeFromIssueType = issueType => ({
  key: issueType,
  name: issueType,
  type: ProjectProgressionAggregatedTableTypeEnum.DYNAMIC_ISSUE_TYPE,
  issueType,
  level: 1,
  sortBy: {
    default: PROGRESSION_MODEL.PROGRESS,
    supportedCols: [PROGRESSION_MODEL.PROGRESS, PROGRESSION_MODEL.STATUS]
  }
});

export const PROGRESSION_TABLE_TYPES = {
  [PM_PROVIDERS.JIRA]: {
    PARENT_2: {
      key: 'PARENT_2',
      name: startCase(jiraViewer.oldIssueParent2.plural),
      type: ProjectProgressionAggregatedTableTypeEnum.INITIATIVES,
      level: 2,
      sortBy: {
        default: PROGRESSION_MODEL.PROGRESS,
        supportedCols: [PROGRESSION_MODEL.PROGRESS, PROGRESSION_MODEL.STATUS]
      }
    },
    PARENT_1: {
      key: 'PARENT_1',
      name: startCase(jiraViewer.oldIssueParent1.plural),
      type: ProjectProgressionAggregatedTableTypeEnum.EPICS,
      level: 1,
      sortBy: {
        default: PROGRESSION_MODEL.PROGRESS,
        supportedCols: [PROGRESSION_MODEL.PROGRESS, PROGRESSION_MODEL.STATUS]
      }
    },
    ISSUES: {
      key: 'ISSUES',
      name: startCase(jiraViewer.ticket.plural),
      type: ProjectProgressionAggregatedTableTypeEnum.ISSUES,
      level: 0,
      sortBy: {
        default: PROGRESSION_MODEL.STATUS,
        supportedCols: [
          PROGRESSION_MODEL.STATUS,
          PROGRESSION_CHILD_MODEL.ASSIGNEE,
          PROGRESSION_CHILD_MODEL.TOTAL
        ]
      }
    }
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    PARENT_2: {
      key: 'PARENT_2',
      name: startCase(azureBoardsViewer.oldIssueParent2.plural),
      type: ProjectProgressionAggregatedTableTypeEnum.EPICS,
      level: 2,
      sortBy: {
        default: PROGRESSION_MODEL.PROGRESS,
        supportedCols: [PROGRESSION_MODEL.PROGRESS, PROGRESSION_MODEL.STATUS]
      }
    },
    PARENT_1: {
      key: 'PARENT_1',
      name: startCase(azureBoardsViewer.oldIssueParent1.plural),
      type: ProjectProgressionAggregatedTableTypeEnum.FEATURES,
      level: 1,
      sortBy: {
        default: PROGRESSION_MODEL.PROGRESS,
        supportedCols: [PROGRESSION_MODEL.PROGRESS, PROGRESSION_MODEL.STATUS]
      }
    },
    ISSUES: {
      key: 'ISSUES',
      name: startCase(azureBoardsViewer.ticket.plural),
      type: ProjectProgressionAggregatedTableTypeEnum.ISSUES,
      level: 0,
      sortBy: {
        default: PROGRESSION_MODEL.STATUS,
        supportedCols: [
          PROGRESSION_MODEL.STATUS,
          PROGRESSION_CHILD_MODEL.ASSIGNEE,
          PROGRESSION_CHILD_MODEL.TOTAL
        ]
      }
    }
  }
};
